import type { RouteObject } from 'react-router';
import { AccountSetupPage, AccountSetupSuccessPage, ResetPasswordPage } from '~/pages/auth';

/**
 * Authentication Routes
 * Handles login, registration, onboarding, and tenant selection
 * 
 * Layout: No MainLayout (full-screen auth pages)
 * Auth Guard: requireNoAuth (redirect to home if already logged in)
 */
export const authRoutes: RouteObject[] = [
  // Account Setup - from email link
  {
    path: 'account-setup',
    element: <AccountSetupPage />,
  },
  // Account Setup Success
  {
    path: 'account-setup-success',
    element: <AccountSetupSuccessPage />,
  },
  // Reset Password - from email link
  {
    path: 'reset-password',
    element: <ResetPasswordPage />,
  },
];
